export const blockIconsBusinessandpaymentsShoppingBagNew = (
	<span className='material-symbols-outlined'>shopping_bag</span>
);
